import React, { useState } from 'react'

import {
  Grid,
  Tooltip,
  ListItemAvatar,
  Typography,
  ListItem,
  ListItemText,
  Button,
  makeStyles,
  useTheme,
} from '@material-ui/core'
import { ShoppingCart } from '@material-ui/icons'

import useViewportSize from '~/components/useViewportSize'
import { useLiterals } from '~/components/Literals'
import { formatName } from '~/utils'
import track from '~/track'

const useStyles = makeStyles(() => ({
  itemAvatar: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: 80,
  },
  moreOffers: {
    height: 'auto',
    textTransform: 'initial',
    padding: 0,
    color: '#1054D1',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 'normal',
    paddingInline: 8,
  },
}))

const IMG_PUBLIC_REPO = 'https://s3.sa-east-1.amazonaws.com/gofind.img.repo/onlinestore'

const StoreName = ({ name, isMobile }) => {
  if (isMobile) {
    return name?.split(' ').map((word, index, arr) => (
      <React.Fragment key={`${word}-${index}`}>
        <Typography component="span" style={{ fontSize: 14, fontWeight: 600 }}>
          {word}
        </Typography>
        {index !== arr.length - 1 && <br />}
      </React.Fragment>
    ))
  }

  return (
    <Typography component="span" style={{ fontSize: 14, fontWeight: 600 }}>
      {name}
    </Typography>
  )
}

export default function StoreItemEcommerce({
  store,
  showValue,
  product,
  isManually,
  handleLogger,
  isLoadingNewOffers,
  offersSameStore,
  onSearchOtherOffers,
}) {
  const classes = useStyles()
  const theme = useTheme()
  const viewport = useViewportSize()
  const { getLiteral } = useLiterals()

  const [imgError, setImgError] = useState(false)

  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const srcImage = `${IMG_PUBLIC_REPO}/${formatName(store.name)}`
  const altImage = `${store.name}-logo`

  const formatPrice = (value) => {
    return new Intl.NumberFormat('pt-br', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(value)
  }

  const handleClick = (store, product, isManually) => {
    handleLogger(store)

    isManually &&
      track('storeOnline', {
        name: store.name,
        category: 'LojasOnline',
      })
    !isManually &&
      track('cliqueLojaOnline', {
        name: store.name,
        category: 'LojasOnline',
      })

    track('verLojaOnline', { name: product.name, category: 'LojasOnline' })
  }

  const handleError = () => {
    setImgError(true)
  }

  return (
    <ListItem>
      <Grid className={classes.itemAvatar}>
        <Tooltip placement="top" title={store.name || ''}>
          <ListItemAvatar style={{ textAlign: 'center' }}>
            {imgError ? (
              <ListItemText
                style={{ padding: '8px 16px 8px 8px' }}
                primary={<StoreName name={store.name} isMobile={isMobile} />}
              />
            ) : (
              <img src={srcImage} alt={altImage} onError={handleError} style={{ width: 70 }} />
            )}
          </ListItemAvatar>
        </Tooltip>
        {store.offerId && !offersSameStore?.find((offer) => offer.name === store.name) && (
          <Button
            variant="text"
            className={classes.moreOffers}
            onClick={onSearchOtherOffers}
            disabled={isLoadingNewOffers}
          >
            {isLoadingNewOffers ? `${getLiteral('1503')}...` : getLiteral('2966')}
          </Button>
        )}
      </Grid>

      {showValue ? (
        <ListItemText
          style={{ flex: 1, alignItems: 'center' }}
          primary={
            <Typography component="span" className={classes.itemPrice}>
              {formatPrice(store.price)}
            </Typography>
          }
        />
      ) : (
        ''
      )}

      <Button
        href={store.url}
        size="small"
        target="_blank"
        component="a"
        onClick={() => handleClick(store, product, isManually)}
        startIcon={<ShoppingCart color="primary" />}
        style={{ marginRight: !isManually && 29 }}
      >
        <Typography variant="body1" style={{ fontSize: 12, fontWeight: 600 }}>
          {isManually ? getLiteral('2393') : getLiteral('2394')}
        </Typography>
      </Button>
    </ListItem>
  )
}
